import { lineHeights } from "./constants";

export const getLineHeight = (size, lineHeight) =>
  lineHeight || lineHeights[size] || 16;
